<!-- Shell desktop — MỘT bố cục duy nhất, không còn nhánh responsive xuống cỡ điện thoại.
     Dưới 768px người dùng được mời sang `/mobile` (MobileViewPromptService); shell giữ
     `min-w-[1024px]` và cuộn ngang thay vì reflow, nên rail/sidebar/toolbar không vỡ. -->
<div class="desktop-shell flex h-screen overflow-hidden">
  <!-- 1. Module rail (MÉP TRÁI, 60px, nền trắng, viền phải) — Carot ERP v2 module-rail.jsx
       (`order:-1`, Q-061). Thứ tự DOM = thứ tự bố cục: rail | sidebar | vùng chính — khoá ở
       shell-v2.contract.spec.ts (F). -->
  <module-rail [navigation]="navigation" class="flex-shrink-0"></module-rail>

  <!-- 2. Sidebar module (sau rail, 234 / thu gọn 62, nền trắng) — Carot ERP v2 -->
  <context-sidebar [(collapsed)]="contextSidebarCollapsed" class="flex-shrink-0"></context-sidebar>

  <!-- 3. Content Area (fluid) -->
  <div class="flex flex-col flex-1 min-w-0 overflow-hidden">
    <!-- 3a. AppTopbar dùng chung (56px) -->
    <top-navbar class="flex-shrink-0"></top-navbar>

    <!-- 3b. Router Outlet — flush with topbar/sidebar/rail (no gutter). Pages own
         their internal padding via ds-page-scaffold / ds-page-header per design. -->
    <!-- Cột dọc: vùng router CUỘN, dải cảnh báo KHÔNG cuộn và nằm CUỐI.
         Trước đây cảnh báo là anh em của <router-outlet> BÊN TRONG chính hộp cuộn. Màn hình bên
         trong lại đặt `h-full`, tức 100% chiều cao hộp cuộn — nên tổng chiều cao = hộp + chiều cao
         dải cảnh báo, và hộp ngoài sinh THÊM một thanh cuộn chồng lên thanh cuộn của chính màn
         (hai thanh cuộn). Cùng lúc, chân trang `shrink-0` của các màn (nút Lưu/Gửi đơn hàng) bị đẩy
         xuống dưới mép nhìn thấy. Tách thành hai hàng flex thì màn nhận đúng phần chiều cao còn
         lại: một thanh cuộn, chân trang dính đáy. `min-h-0` là bắt buộc — mặc định `min-height:auto`
         của flex item không cho con co lại dưới nội dung. -->
    <!-- data-inpage-host: vùng chủ của "in-page panel" (Carot ERP v2) — DsDialogService.open với
         position 'inpage' phủ đúng hộp này, giữ sidebar + topbar + rail. 'relative' là mốc
         định vị của lớp phủ tuyệt đối. Nền trang #F8F9FB qua token (`bg-surface`).
         Đệm 16×22×28 của thiết kế KHÔNG đặt ở đây: shell cố ý sát mép (Alex 23/05, màn tự
         lo đệm) — đệm nằm trong `ds-page-scaffold` (biến --page-pad-*), nên in-page panel
         phủ kín vùng này mà không hở viền. -->
    <div class="relative flex-1 min-h-0 flex flex-col bg-surface min-w-0" data-inpage-host>
      <div class="flex-1 min-h-0 overflow-auto">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

<!-- 4. Context Selector Panel — hộp nổi neo cạnh rail (rail ở mép trái), phủ lên sidebar. -->
@if (contextSelectorOpen) {
  <context-selector-panel
    [tenants]="tenants"
    [businessUnits]="businessUnits"
    [facilities]="facilities"
    [selectedTenant]="selectedTenant"
    [selectedBusinessUnit]="selectedBusinessUnit"
    [selectedFacility]="selectedFacility"
    [allowedBusinessUnitIds]="allowedBusinessUnitIds"
    [allowedFacilityIds]="allowedFacilityIds"
    [isAdmin]="isAdmin"
    [rememberedSelection]="contextSelectorService.lastAppliedSelection()"
    (applyContext)="onApplyContext($event)"
    (closePanel)="contextSelectorService.close()"
  ></context-selector-panel>
}
